/* CRUX Circle — shared product-save engine + header badge (P0-2/3, 2026-07-27).
   One door for PRODUCT saves anywhere in the theme: any element with
   [data-cx-save][data-product-id][data-handle] becomes a live save toggle.
   Look saves stay in cx-lookbook (its own machinery, untouched) — this file
   only READS their mirror for the badge count.
   Device identity = eon_anon (same as the beacon → identity stitch free).
   POST body is text/plain to skip the CORS preflight (established pattern).
   Fail-open: a dead network never blocks the UI — the mirror is the UI's
   truth and the server catches up on the next toggle. */
(function () {
  'use strict';
  if (window.CXCircle) return;

  var BASE = 'https://eondiscovery.co/api/storefront';
  var SHOP = (window.Shopify && window.Shopify.shop) || '';

  function dev() {
    try {
      var d = localStorage.getItem('eon_anon');
      if (!d) {
        d = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        localStorage.setItem('eon_anon', d);
      }
      return d;
    } catch (e) { return ''; }
  }

  function mirror() {
    try { return JSON.parse(localStorage.getItem('cx_circle_psaves') || '[]'); }
    catch (e) { return []; }
  }
  function looksMirror() {
    try { return JSON.parse(localStorage.getItem('cx_circle_saves') || '[]'); }
    catch (e) { return []; }
  }
  function writeMirror(list) {
    try { localStorage.setItem('cx_circle_psaves', JSON.stringify(list.slice(0, 200))); }
    catch (e) {}
  }

  function post(payload) {
    try {
      // Account-linked saves (P0-4): a logged-in customer's id rides
      // every save, so the row is account-scoped from birth.
      if (window.__cxCid) payload.customer_shopify_id = String(window.__cxCid);
      fetch(BASE + '/circle/save?shop=' + encodeURIComponent(SHOP), {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  // One-time per session: stamp the customer onto this device's EXISTING
  // save history (server fills only NULL links — see /circle/link).
  function linkAccount() {
    try {
      if (!window.__cxCid || sessionStorage.getItem('cx_linked')) return;
      sessionStorage.setItem('cx_linked', '1');
      fetch(BASE + '/circle/link?shop=' + encodeURIComponent(SHOP), {
        method: 'POST', mode: 'cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ device_id: dev(),
                               customer_shopify_id: String(window.__cxCid) })
      }).catch(function () {});
    } catch (e) {}
  }

  function isSaved(id) {
    id = String(id);
    return mirror().some(function (p) { return String(p.id) === id; });
  }

  function toggle(id, handle) {
    id = String(id);
    var list = mirror();
    var on = !list.some(function (p) { return String(p.id) === id; });
    if (on) list.unshift({ id: id, handle: handle || '' });
    else list = list.filter(function (p) { return String(p.id) !== id; });
    writeMirror(list);
    post({ device_id: dev(), kind: 'product', ref_id: id,
           action: on ? 'add' : 'remove', source: 'theme',
           handle: handle || '' });
    badge();
    paintAll();
    return on;
  }

  function count() { return mirror().length + looksMirror().length; }

  function badge() {
    var els = document.querySelectorAll('[data-cx-saved-count]');
    var n = count();
    els.forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }

  function paintAll() {
    document.querySelectorAll('[data-cx-save]').forEach(function (btn) {
      var on = isSaved(btn.getAttribute('data-product-id'));
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cx-save]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-product-id'), btn.getAttribute('data-handle'));
  });

  window.addEventListener('storage', function (e) {
    if (e.key === 'cx_circle_psaves' || e.key === 'cx_circle_saves') { badge(); paintAll(); }
  });

  // WA claim-code handoff (operator GO 2026-07-27): every wa.me door
  // gains "· ref <device-tail>" in its prefilled text, so the inbound
  // side can join THIS device's story (saves, cart) to the thread the
  // moment the customer says hello. One interceptor covers every door —
  // notify-me, exit popup, store links, whatever ships next.
  function refTag() {
    var d = dev();
    return d ? 'ref ' + d.replace(/-/g, '').slice(-6).toUpperCase() : '';
  }
  function stampWa(a) {
    try {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('wa.me') === -1 || href.indexOf('ref%20') > -1) return;
      var tag = refTag();
      if (!tag) return;
      var enc = encodeURIComponent(' · ' + tag);
      a.setAttribute('href', href.indexOf('text=') > -1
        ? href.replace(/(text=[^&]*)/, '$1' + enc)
        : href + (href.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(tag));
    } catch (e) {}
  }
  ['pointerdown', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('a[href*="wa.me"]');
      if (a) stampWa(a);
    }, true);
  });

  window.CXCircle = { toggle: toggle, isSaved: isSaved, count: count,
                      badge: badge, paintAll: paintAll, mirror: mirror,
                      refTag: refTag };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { badge(); paintAll(); linkAccount(); });
  } else { badge(); paintAll(); linkAccount(); }
})();
